export const KISA_MIGRATION_LOGIN =
  'RELEASE_TOGGLE_SMART_3848_ENABLE_KISA_MIGRATION';

export const CHAT_BEFORE_LOGIN =
  'RELEASE_TOGGLE_SMART_3982_ENABLE_CHAT_BEFORE_LOGIN ';

export const CONTACT_DETAILS =
  'RELEASE_TOGGLE_SMART_4481_CONTACT_DETAILS_FRONT';

export const CONTRACTS_DASHBOARD =
  'RELEASE_TOGGLE_SMART_4402_CONTRACTS_DASHBOARD';

export const CONTRACT_DETAILS =
  'RELEASE_TOGGLE_SMART_3964_CONTRACT_DETAILS_FRONT';

export const CONSENTS_AND_OBLIGATIONS =
  'RELEASE_TOGGLE_SMART_3969_CONSENTS_AND_OBLIGATIONS';

export const CLIENT_SYNCHRONIZATION =
  'RELEASE_TOGGLE_SMART_3990_USE_CLIENT_DATA_FROM_SYNCHRONIZATION';
